export const coloreDisponibile = "#28a745"
export const coloreOccupato = "#dc3545"
export const coloreDisabilitata = "#979797"
export const coloreRiservata = "#979797"
export const coloreCheckIn ="#ffc107"